'use client';

import cx from 'clsx';
import { getGlobalClassNames } from './get-global-class-names/get-global-class-names.mjs';
import { getOptionsClassNames } from './get-options-class-names/get-options-class-names.mjs';
import { getResolvedClassNames } from './get-resolved-class-names/get-resolved-class-names.mjs';
import { getRootClassName } from './get-root-class-name/get-root-class-name.mjs';
import { getSelectorClassName } from './get-selector-class-name/get-selector-class-name.mjs';
import { getStaticClassNames } from './get-static-class-names/get-static-class-names.mjs';
import { getThemeClassNames } from './get-theme-class-names/get-theme-class-names.mjs';
import { getVariantClassName } from './get-variant-class-name/get-variant-class-name.mjs';
function getClassName(_ref) {
  var theme = _ref.theme,
    options = _ref.options,
    themeName = _ref.themeName,
    selector = _ref.selector,
    classNamesPrefix = _ref.classNamesPrefix,
    classNames = _ref.classNames,
    classes = _ref.classes,
    unstyled = _ref.unstyled,
    className = _ref.className,
    rootSelector = _ref.rootSelector,
    props = _ref.props,
    stylesCtx = _ref.stylesCtx,
    withStaticClasses = _ref.withStaticClasses,
    headless = _ref.headless,
    transformedStyles = _ref.transformedStyles;
  return cx(getGlobalClassNames({
    theme: theme,
    options: options,
    unstyled: unstyled || headless
  }), getThemeClassNames({
    theme: theme,
    themeName: themeName,
    selector: selector,
    props: props,
    stylesCtx: stylesCtx
  }), getVariantClassName({
    options: options,
    classes: classes,
    selector: selector,
    unstyled: unstyled
  }), getResolvedClassNames({
    selector: selector,
    stylesCtx: stylesCtx,
    theme: theme,
    classNames: classNames,
    props: props
  }), getResolvedClassNames({
    selector: selector,
    stylesCtx: stylesCtx,
    theme: theme,
    classNames: transformedStyles,
    props: props
  }), getOptionsClassNames({
    selector: selector,
    stylesCtx: stylesCtx,
    options: options,
    props: props,
    theme: theme
  }), getRootClassName({
    rootSelector: rootSelector,
    selector: selector,
    className: className
  }), getSelectorClassName({
    selector: selector,
    classes: classes,
    unstyled: unstyled || headless
  }), withStaticClasses && !headless && getStaticClassNames({
    themeName: themeName,
    classNamesPrefix: classNamesPrefix,
    selector: selector,
    withStaticClass: options === null || options === void 0 ? void 0 : options.withStaticClass
  }), options === null || options === void 0 ? void 0 : options.className);
}
export { getClassName };